
import { Radio } from 'element-ui';
export default {
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    paymentMethod: {
      type: Object,
    },
    title: {
      type: String,
    },
    stitle: {
      type: String,
    },
  },
  components: {
    Radio,
  },
};
